exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.current-color {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    background-color: #000;\n    cursor: pointer;\n}\n.color-picker-container{\n    position: relative;\n    left: -30px;\n    top: 4px;\n}\n.uk-color-picker input{\n    width: calc(100% - 25px);\n}\n", ""]);

// exports
